import { render } from "./BackTop.vue?vue&type=template&id=288ccdf1&scoped=true"
import script from "./BackTop.vue?vue&type=script&lang=js"
export * from "./BackTop.vue?vue&type=script&lang=js"

import "./BackTop.vue?vue&type=style&index=0&id=288ccdf1&scoped=true&lang=less"

import exportComponent from "/home/huiwen/TeamCity/buildAgent/work/78c9eac71a3ca1e9/webs/pdam-app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-288ccdf1"]])

export default __exports__